@if (brandingKey !== CustomClients.WestLotto) {
  @if (screenSizeDetectorService.isLargeScreen && asset.status !== Status.Draft) {
    <button mat-menu-item (click)="editAssets.emit('metaData')" *ngIf="AnyAsset | can: 'update'">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span i18n>Edit metadata</span>
    </button>
    <button mat-menu-item (click)="editAssets.emit('usageRights')" *ngIf="AnyAsset | can: 'usagerights'">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span i18n>Edit usage rights</span>
    </button>
    <button mat-menu-item (click)="editAssets.emit('relations')" *ngIf="AnyAsset | can: 'relations'">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span i18n>Edit relations</span>
    </button>
  }

  <span
    class="cursor-pointer"
    *ngIf="
      asset.status !== Status.Draft && !configObject?.hideDownload && (AccessAsset(asset) | can: 'download') && ((asset.expiryDate | dateNotExpired) || (AccessAsset(asset) | can: 'expired.download'))
    "
  >
    <button mat-menu-item [disabled]="asset.inProgress" (click)="downloadAsset.emit({ asset: asset, name: asset.mainFile.name })">
      <mat-icon>
        <span class="material-icons-outlined">file_download</span>
      </mat-icon>
      <span>
        @if ([CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)) {
          <ng-container i18n>Download</ng-container>
        } @else {
          <ng-container i18n>Download asset</ng-container>
        }
      </span>
    </button>
  </span>
  <span class="cursor-pointer" *ngIf="asset.status !== Status.Draft && (AccessAsset(asset) | can: 'share') && (asset.expiryDate | dateNotExpired)">
    <button mat-menu-item [disabled]="asset.inProgress" (click)="shareAsset.emit(asset)">
      <mat-icon>
        <span class="material-icons-outlined">share</span>
      </mat-icon>
      <span i18n>Share asset</span>
    </button>
  </span>

  @if (screenSizeDetectorService.isLargeScreen) {
    <span class="cursor-pointer">
      <button *ngIf="asset.status !== Status.Draft && (AnyAsset | can: 'collection.create') && (!configObject || !configObject?.hideAddToCollection)" mat-menu-item (click)="addToCollection.emit()">
        <mat-icon class="material-icons-outlined">perm_media</mat-icon>
        <span i18n>Add to collection</span>
      </button>
    </span>
    <ng-container *ngIf="asset.status !== Status.Draft">
      <span class="cursor-pointer" *ngIf="!configObject?.hideDelete && (AccessAsset(asset) | can: 'delete')">
        <button mat-menu-item [disabled]="asset.inProgress" (click)="deleteAsset.emit({ asset: asset, id: asset._id })">
          <mat-icon>
            <span class="material-icons-outlined">delete_outline</span>
          </mat-icon>
          <span>
            <ng-container *ngIf="![CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)" i18n>Delete asset</ng-container>
            <ng-container *ngIf="[CustomClients.VKB, CustomClients.SEAT].includes(brandingKey)" i18n>Delete</ng-container>
          </span>
        </button>
      </span>
      <span class="cursor-pointer" *ngIf="[CustomClients.VKB, CustomClients.Standard].includes(brandingKey) && !configObject?.hideDelete && (AccessAsset(asset) | can: 'plandeletion')">
        <button mat-menu-item [disabled]="asset.inProgress" (click)="deleteAsset.emit({ asset: asset, id: asset._id, planDeletionFlag: true })">
          <mat-icon>
            <span class="material-icons-outlined">delete_outline</span>
          </mat-icon>
          <span i18n>Plan deletion</span>
        </button>
      </span>
    </ng-container>
    <span class="cursor-pointer">
      <button
        *ngIf="configObject?.callFrom === 'collection' && collectionOwner"
        mat-menu-item
        type="button"
        i18n-matTooltip
        matTooltip="Remove from collection"
        (click)="removeFromCollection.emit(asset['_id'])"
      >
        <mat-icon>
          <span class="material-icons-outlined">{{ [CustomClients.Vorwerk].includes(brandingKey) ? 'gallery_off' : 'folder_off' }}</span>
        </mat-icon>
        <span i18n>Remove from collection</span>
      </button>
    </span>
  }
}
